import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tooltip} from 'antd';
import {ReactNode} from 'react';

import {Locale} from '../../provider/locale/locale';
import {LangKeyType} from '../../provider/locale/translation/type';

import * as styles from './publication-field-label.scss';

type PropsType = {
    labelLangKey: LangKeyType;
    tooltip: ReactNode;
    // The required-field asterisk sits right after the label text, so fields that own their rules
    // elsewhere (and render the label manually) put the icon after it to keep the asterisk readable.
    iconPosition?: 'before' | 'after';
};

// Form-field label with an info-tooltip icon, used only for fields that need an extra explanation
// (e.g. the difference between the event/promotion active period and the publication display period,
// or the image requirements of the content field).
export function PublicationFieldLabel({labelLangKey, tooltip, iconPosition = 'before'}: PropsType): JSX.Element {
    const icon = (
        <Tooltip title={tooltip}>
            <span className={styles.PublicationFieldLabel_icon}>
                <FontAwesomeIcon icon={faCircleInfo} />
            </span>
        </Tooltip>
    );

    return (
        <span className={styles.PublicationFieldLabel}>
            {iconPosition === 'before' && icon}
            <Locale stringKey={labelLangKey} />
            {iconPosition === 'after' && icon}
        </span>
    );
}
